import React, {useEffect, useState} from "react";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {useTranslate} from "../../../system/useTranslate";
import GoalParentSelect, {MISSION_PARENT, goalAndDescendantIds} from "./goal-parent-select";

/**
 * Unlinking a goal from its parent is only possible by moving it under another parent,
 * because every goal must have one (the mission or another goal). Projects do not use this dialog.
 */
function GoalReparentDialog({visible, goalData, goals, onHide, onConfirm}) {
    const translate = useTranslate();
    const [parentChoice, setParentChoice] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (visible) {
            setParentChoice(null);
            setSubmitting(false);
        }
    }, [visible, goalData?.id]);

    const currentParentId = goalData?.parentGoal?.id;
    const hasGoalParent = currentParentId !== undefined && currentParentId !== null;
    const excludeIds = goalData ? goalAndDescendantIds(goals, goalData.id) : undefined;
    if (excludeIds && hasGoalParent) excludeIds.add(String(currentParentId));

    const submit = async () => {
        if (submitting) return;
        setSubmitting(true);
        try {
            await onConfirm?.(goalData, parentChoice);
        } finally {
            setSubmitting(false);
        }
    };

    return(
        <Dialog
            visible={visible}
            onHide={onHide}
            header={translate("confirm")}
            className="rtl w-30rem"
            pt={{root: () => ({className: "border-round-2xl"}), footer: () => ({className: "border-round-bottom-2xl"})}}
            footer={
                <div className="flex flex-row-reverse gap-2">
                    <Button className="p-button-danger text-xs" label={translate("strategy-map.action.disconnect")} disabled={submitting} loading={submitting} onClick={submit}/>
                    <Button className="p-button-text text-xs" label={translate("cancel")} onClick={onHide}/>
                </div>
            }>
            <div className="flex flex-column gap-3">
                <div className="text-sm">{translate("strategy-map.confirm.disconnect")}</div>
                <div className="text-xs text-500">{translate("goal-disconnect-select-parent-hint")}</div>
                <GoalParentSelect
                    value={parentChoice}
                    onChange={setParentChoice}
                    goals={goals}
                    excludeIds={excludeIds}
                    includeMission={hasGoalParent}
                />
            </div>
        </Dialog>
    )
}

export default GoalReparentDialog;
